import { render } from "./ArticleShareModal.vue?vue&type=template&id=57c32113&ts=true&lang=pug"
import script from "./ArticleShareModal.vue?vue&type=script&lang=ts"
export * from "./ArticleShareModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__